import ChatFrame from "./ChatFrame";
import './zeroagent.css';

export interface ZeroagentType {
  appID: string;
  appKey: string;
}

if (process.env.NODE_ENV === "production") {
  console.log = () => {};
}

const Zeroagent: React.FC<ZeroagentType> = ({ appID, appKey }) => {
 
  if (!appID || !appKey) {
    console.error("you must specify appID & appKey");
    return <></>; // Prevent rendering if either is missing
  }

  return ( 
      <ChatFrame appID={appID} appKey={appKey} />
  );
};

export default Zeroagent;
